import { Navigate, Outlet, useLocation } from 'react-router'

import { useAuth, useTranslation } from '@molecule/app-react'

import { hasGuestCookie } from '../utilities/guestClaim.js'

/** Props for {@link AuthGuard}. */
export interface AuthGuardProps {
  /**
   * Also admit GUEST sessions (the `mol_guest_uid` cookie): guests aren't
   * `isAuthenticated` client-side, but their httpOnly token cookie
   * authenticates API calls, so guest-usable pages (the dashboard) render
   * fine. Auth-only pages (billing, analytics) omit this and keep the
   * login redirect.
   */
  allowGuest?: boolean
}

export function AuthGuard({ allowGuest = false }: AuthGuardProps) {
  const { isAuthenticated, state } = useAuth()
  const { t } = useTranslation()
  const location = useLocation()

  if (!state.initialized) return <div>{t('common.loading')}</div>
  if (!isAuthenticated && !(allowGuest && hasGuestCookie()))
    return <Navigate to="/login" state={{ from: location }} replace />

  return <Outlet />
}
